
import {Context} from '@nuxt/types';
import _ from 'lodash';
import Vue from 'vue';
import {MetaInfo} from 'vue-meta/types/vue-meta';
import BrowserExtensionOrAppBanner from '~/components/page-components/BrowserExtensionOrAppBanner.vue';
import PageNotificationBar from '~/components/page-components/PageNotificationBar.vue';
import SectionPodopieczny from '~/components/page-components/SectionPodopieczny.vue';
import SectionTitle from '~/components/page-components/SectionTitle.vue';
import PageSection from '~/components/PageSection.vue';
import {childHtmlHead} from '~/etc/nuxt.config.head';
import {childGetSingleStore} from '~/lib/accessors/store-accessor';
import ChildView from '~/lib/types/ChildView';


export default Vue.extend({
  components: {PageNotificationBar, SectionTitle, PageSection, BrowserExtensionOrAppBanner, SectionPodopieczny},
  head(): MetaInfo {
    return childHtmlHead(this.child);
  },
  data() {
    return {
      sections: {
        pomozTejOsobie: {},
        jakToDziala: {},
      }
    }
  },
  async asyncData({ route, $axios, redirect, $content }: Context) {
    const pages: any = await $content('pages/podopieczny')
      .sortBy('slug', 'asc')
      .fetch()
    const pomozTejOsobie = _.find(pages, p => p.slug === '1-pomoz-tej-osobie')
    const jakToDziala = _.find(pages, p => p.slug === '2-jak-to-dziala')

    // For backwards compatibility allow old URLs with child.id, which is a numeric
    // integer value (KIPR-32).
    if(/^\d+$/.test(route.params['slug'])) {
      return redirect({name: 'podopieczny-slug', params: {
        slug: await getActualSlug(route.params['slug'])
      }});
    }

    return {
      sections: {
        pomozTejOsobie,
        jakToDziala
      },
    }

    async function getActualSlug(childId: string) {
        return (await $axios.get(`/children/id-to-slug/${childId}`)).data.slug;
    }
  },
  beforeRouteLeave(to: any, from: any, next: any) {
    childGetSingleStore.purge();
    next();
  },
  mounted() {
    childGetSingleStore.fetchSingleBySlug(this.$route.params['slug'])
  },
  computed: {
    child(): ChildView {
      return childGetSingleStore.child;
    },
    childSlug(): string {
      return this.child.slug;
    },
    isAlert(): boolean {
      return 'alert' in this.$route.query;
    }
  },
});
